/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOLeaveApplied from "./DTOLeaveApplied";
import LeaveAppliedPresenter from "./LeaveAppliedPresenter";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function LeaveAppliedController() {
  const { t, i18n } = useTranslation();
  const [allLeavesData, setAllLeavesData] = useState([]);
  const [typeFilter, setTypeFilter] = useState<string>('');
  const isLoading = useAppSelector(
    (state) => state.leaveAppliedSlice.refreshLeaveApplied
  );
  function callBackFunc(data: any) {
    setAllLeavesData(data);
  }

  const getTypeFilter = (type: string) => {
    setTypeFilter(type);
  };
  return (
    <>
      <DTOLeaveApplied setLeaveAppliedData={callBackFunc} 
        typeFilter={typeFilter}/>
      <LeaveAppliedPresenter
        leaveData={allLeavesData}
        isLoading={isLoading}
        setTypeFilter={getTypeFilter}
        trans={t}
        i18n={i18n}
      />
    </>
  );
}

export default LeaveAppliedController;
